import { render, staticRenderFns } from "./ticketStatisticsWindow.vue?vue&type=template&id=06290105&scoped=true"
import script from "./ticketStatisticsWindow.vue?vue&type=script&lang=js"
export * from "./ticketStatisticsWindow.vue?vue&type=script&lang=js"
import style0 from "./ticketStatisticsWindow.vue?vue&type=style&index=0&id=06290105&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06290105",
  null
  
)

export default component.exports